export default {
  state: {
    /**
     * Список всех постов и их количество
     */
    news: [],
    theNews: {},
    totalCount: "",
    currentPage: "",
    perPage: 10
  },
  actions: {
    /**
     * Получает список всех постов и их общее количество
     */
    async fetchNews({ commit, state }) {
      try {
        const response = await fetch(`${process.env.VUE_APP_KZ}/news/list`);

        const { content, pagerInfo } = await response.json();
        const materialsCount = pagerInfo?.materialsCount;
        const currPage = pagerInfo?.currPage;
        state.totalCount = materialsCount;
        state.currentPage = +currPage;
        commit("pushPostNews", content);
      } catch (e) {
        console.error(e);
        throw e;
      }
    },

    async fetchTheNews({ commit, state }, id) {
      try {
        const response = await fetch(`${process.env.VUE_APP_KZ}/news/${+id}`);

        const { content, pagerInfo } = await response.json();
        const materialsCount = pagerInfo?.materialsCount;
        const currPage = pagerInfo?.currPage;
        state.totalCount = materialsCount;
        state.currentPage = +currPage;
        commit("pushPostTheNews", content);
      } catch (e) {
        console.error(e);
        throw e;
      }
    }
  },
  mutations: {
    /**
     * Добавляет новости на страницу
     */
    pushPostNews(state, news) {
      state.news = [...news];
    },
    /**
     * Добавляет новости на страницу
     */
    pushPostTheNews(state, news) {
      state.theNews = news;
    }
  },
  getters: {
    news: state => state.news,
    theNews: state => state.theNews
  }
};
